import { render, staticRenderFns } from "./StatsRadialBasic.vue?vue&type=template&id=2d7f6eb0&scoped=true"
import script from "./StatsRadialBasic.vue?vue&type=script&setup=true&lang=js"
export * from "./StatsRadialBasic.vue?vue&type=script&setup=true&lang=js"
import style0 from "./StatsRadialBasic.vue?vue&type=style&index=0&id=2d7f6eb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7f6eb0",
  null
  
)

export default component.exports